import React, { useState } from 'react';
import { FieldGroup, Modal, PillButton, Row, Stack, Text, TextInput } from 'library/ui';
import { client } from 'shared';

export default function EditPayModal({
    open,
    onClose,
    initialPay,
    jobId,
    workerUserId,
    refresh,
}: {
    open: boolean;
    onClose: () => void;
    initialPay: number;
    jobId: number;
    workerUserId: number;
    refresh: () => void;
}) {
    const [pay, setPay] = useState(initialPay.toString());
    const errorMessage =
        Number(pay) >= initialPay
            ? ''
            : 'You cannot decrease the pay rate after a shift is booked. Please contact Tandem for assistance.';

    function handleSave() {
        client(`api/business-job/${jobId}/update-pay`, {
            method: 'POST',
            body: {
                pay,
                worker_user: workerUserId,
            },
        }).then(() => {
            onClose();
            refresh();
        });
    }

    if (!open) {
        return null;
    }

    return (
        <Modal title="Edit Pay Rate" onClose={onClose} width={400}>
            <Stack gap="md">
                <Text size="md" lineHeight="relaxed" component="p">
                    The pay rate for all unpaid shifts for this teacher and job will be updated to the amount you enter.
                    You can only increase pay after a shift is booked. If you need help with a past shift or other
                    change, please contact us through the chat or by emailing us at team@join-tandem.com.
                </Text>
                <FieldGroup label="Pay Rate ($)">
                    <TextInput value={pay} onChange={setPay} fullWidth />
                </FieldGroup>
                {errorMessage && (
                    <Text size="md" tone="error">
                        {errorMessage}
                    </Text>
                )}
                <Row justify="end" fullWidth>
                    <PillButton variant="secondary" onClick={onClose}>
                        Cancel
                    </PillButton>
                    <PillButton disabled={!!errorMessage} onClick={handleSave}>
                        Save
                    </PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
